export default __webpack_public_path__ + "static/media/radio-background.616ea09d.svg";